module.exports = __webpack_public_path__ + "static/media/moduleSet_i0o5.cc419bf9.jpg";